import { ReactNode } from 'react';

import { HStack, IconButton, Text, VStack } from '@chakra-ui/react';
import { MdKeyboardArrowLeft, MdOutlineLockClock, MdSmartToy } from 'react-icons/md';
import { useHistory } from 'react-router-dom';

import { DealLockStatus } from '../../../gql/generated/graphql';

import ROUTES from '../../../constants/routes';

type CardContent = {
  description: string;
  icon: ReactNode;
};

const cardContent: Record<DealLockStatus, CardContent> = {
  [DealLockStatus.AiCall]: {
    description: 'This deal is locked while on AI call.',
    icon: <MdSmartToy size={20} />,
  },
  [DealLockStatus.CustomerEntry]: {
    description: 'This deal is locked while on customer entry.',
    icon: <MdOutlineLockClock size={20} />,
  },
  [DealLockStatus.MovingToClosing]: {
    description: 'This deal is moving deal states.',
    icon: <MdOutlineLockClock size={20} />,
  },
};

type LockedReasonCardProps = {
  lockedReason: DealLockStatus;
};

const LockedReasonCard = ({ lockedReason }: LockedReasonCardProps) => {
  const history = useHistory();

  return (
    <VStack
      position="absolute"
      bottom={6}
      right={6}
      align="flex-start"
      bg="white"
      borderRadius="12px"
      boxShadow="2xl"
      minW="280px"
      maxW="320px"
      p={3}
      border="1px solid"
      borderColor="gray.800"
      spacing={2}
    >
      <HStack spacing={1}>
        <IconButton
          aria-label="Back"
          icon={<MdKeyboardArrowLeft size={16} />}
          onClick={() => history.push(ROUTES.DASHBOARD)}
          color="gray.500"
          variant="ghost"
          minW="auto"
          h="25px"
        />
        {cardContent[lockedReason].icon}
        <Text fontWeight="bold" color="gray.700">
          Deal Locked:
        </Text>
      </HStack>
      <Text px={2} color="gray.600" fontSize="sm">
        {cardContent[lockedReason].description}
      </Text>
    </VStack>
  );
};

export default LockedReasonCard;
